export default __webpack_public_path__ + "static/modal5-d8debe2b39ce80f06bbf4e27695b45d9.png";